import React, { useEffect, useState } from "react";
import { compose } from "recompose";
import { Table, Button, Alert } from "reactstrap";
import { AddNewButton, EditDeleteButtons, Page, withTable } from "components/common";
import { Trans } from "react-i18next";
import BackButton from "./../BackButton"
import { deductionNotes as importantNotes } from "pages/UserList/modelNames";
import { NotificationManager } from "react-notifications";
import ImportModal from "components/ImportModal";
import { humanError } from "services/util";
import qs from "query-string";

export const DeductionsList = ({
  TableContainer,
  match,
  data,
  Pagination,
  onDeleteItem,
  PayrollTableDataFetch,
  PayrollBulkDeleteButton,
  TableSearch,
  url,
  payroll,
  t,
  refreshData,
  history, 
}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [settingsMessage, setSettingsMessage] = useState('');
  
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleUploadFile = async (selectedFile) => {

    const formData = new FormData();
    setIsLoading(true)
    formData.append('file', selectedFile)

    payroll.post(`${url}/bulk_import`, formData)
      .then(({ data }) => {
        setIsLoading(false)
        NotificationManager.success(t("File imported successfully"));
        setTimeout(() => {
          setIsModalOpen(false);
          refreshData()
        }, 800);
      })
      .catch((err) => {
        setIsLoading(false);
        const error_message = humanError(err, "Error while importing File", t)
        NotificationManager.error(error_message);
        refreshData()
      });
  }

  useEffect(() => { 
    const query = qs.parse(history?.location?.search);
    if (query.debit_account === '') {
      setSettingsMessage('User needs to configure the account in the Accounts Settings.')
    }
  }, [])

  return (
    <Page title="" className="inv-table">
      <BackButton/>
    <h4 style={{marginTop:"15px",marginBottom:"20px"}}><Trans>Deduction Rules</Trans></h4>
    <div style={{display:"flex"}}>
      <div className="col-6" style={{paddingLeft:"0px"}}> <TableSearch /></div>
      <div>
          <AddNewButton resource="Deduction" match={match} />

          <Button size="md" color="primary" onClick={openModal}>
            <Trans>Import</Trans><span className="mx-1" /><i className="fas fa-file-excel" />
          </Button>
      </div>
    </div>
    <PayrollBulkDeleteButton className="d-none" />

    {settingsMessage && <Alert color="warning" className="mt-4 text-center">
      <h4 className="my-0"><Trans>{settingsMessage}</Trans></h4>
    </Alert>}
    
    <TableContainer>
      <Table className="no-wrap v-middle text-center" responsive>
        <thead>
          <tr>
            <th sortBy="description" className="text-nowrap">
              <Trans>Description</Trans>
            </th>
            <th sortBy="amount" className="text-nowrap">
              <Trans>Amount</Trans>
            </th>
            <th sortBy="amount_type" className="text-nowrap">
              <Trans>Amount Type</Trans>
            </th>
            <th className="text-nowrap">
              <Trans>Apply To</Trans>
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
        {data.results.map((i) => (
          <tr key={i.id}>
            <td>{i.description}</td>
            <td>{i.amount}</td>
            <td>{i.amount_type_display}</td>
            <td>{i.apply_to_employees?.map((item, idx) => `${item.value === true ? item.name : ''} ${
              idx === i.apply_to_employees?.length - 1 ? '' : item.value === true ? '/ ' : ''}`)}</td>
            <td className="text-end text-nowrap">
              <EditDeleteButtons
                url={match.url}
                id={i.id}
                onDelete={onDeleteItem}
              />
            </td>
          </tr>
        ))}
        </tbody>
      </Table>
    </TableContainer>
    <PayrollTableDataFetch />

    <ImportModal
      isOpen={isModalOpen}
      toggle={closeModal}
      title="DeductionRules"
      importantNotes={importantNotes}
      handleUpload={handleUploadFile}
    />
    <div className="clearfix">
      <div className="float-right"><Pagination /></div>
    </div>
  </Page>
)}

const enhance = compose(withTable({ limit: 100, url: "deductions" }));

export default enhance(DeductionsList);
